<div id="sidebar-collapse" class="sidebar">

    <div class="admin-block d-flex" style="align-items: center;">
        <div>
            <img src="./../../../assets/img/dash/PET.jpg" class="img-circle" width="45px" />
        </div>
        <div class="admin-info">
            <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['PR']}}</div>
        </div>
    </div>
    <ul class="side-menu metismenu">
        <li  [hidden]="sidebar['dashbord']">
            <a class = "text-decoration-none"  routerLinkActive="active" (click)="refreshCol()" routerLink="/pet/pet-index"><i class="sidebar-item-icon fa fa-th-large"></i>
                <span class="nav-label"> Dashboard </span>
            </a>
        </li>
        <li [hidden]="sidebar['registration']">
            <a class = "text-decoration-none"  routerLinkActive="active" (click)="refreshCol()" routerLink="/pet/pet-reg"><i class="sidebar-item-icon fa fa-user" aria-hidden="true"></i>
                <span class="nav-label"> Registration </span>
            </a>
        </li>
        <li [hidden]="sidebar['cancellation']">
            <a class = "text-decoration-none"  routerLinkActive="active" (click)="refreshCol()" routerLink="/pet/pet-cancel"><i class="sidebar-item-icon fa fa-user-times"></i>
                <span class="nav-label"> Cancellation </span>
            </a>
        </li>
        <li [hidden]="sidebar['renewal']">
            <a class = "text-decoration-none"  routerLinkActive="active" (click)="refreshCol()" routerLink="/pet/pet-issue"><i class="sidebar-item-icon fa fa-vcard-o"></i>
                <span class="nav-label"> Renewal </span>
            </a>
        </li>
        <li [hidden]="sidebar['penality']">
            <a class = "text-decoration-none"  routerLinkActive="active" (click)="refreshCol()" routerLink="/pet/pet-penalty"><i class="sidebar-item-icon fa fa-money"></i>
                <span class="nav-label"> Penalty </span>
            </a>
        </li>
        <li routerLinkActive="active" >
            <a class="text-decoration-none" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin" [hidden]="sidebar['administration']"
            aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-database"></i>
                <span class="nav-label">Administration</span><i class="fa fa-angle-left arrow"></i></a>
            <ul  class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse" >
              <div id="adminParent">
                 <li>
                    <a   class="text-decoration-none"  href="#" data-bs-toggle="collapse" data-bs-target="#set"
                    aria-expanded="false" aria-controls="set" [hidden]="sidebar['master_data']">
                        <span class="nav-label">Master Data</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul  class="nav-3-level collapse" id="set" data-bs-parent="#adminParent" >



                        <li [hidden]="sidebar['master_data']">
                            <a routerLink="/pet/ustp-setting/code-value" routerLinkActive="active">Code Value</a>
                        </li>
                        <li [hidden]="sidebar['master_data']">
                            <a routerLink="/pet/ustp-setting/field" routerLinkActive="active">Field</a>
                        </li>
                        <li [hidden]="sidebar['master_data']">
                            <a routerLink="/pet/ustp-setting/hierachy" routerLinkActive="active">
                                Hierachy
                            </a>
                        </li>

                    </ul>
                </li>

                <li>
                    <a  lass="text-decoration-none"  href="#" data-bs-toggle="collapse" data-bs-target="#sec"
                    aria-expanded="false" aria-controls="sec" [hidden]="sidebar['security']">
                        <span class="nav-label">Security</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul class="nav-3-level collapse" id="sec" data-bs-parent="#adminParent" >
                        <li [hidden]="sidebar['security']">
                            <a  routerLink="/pet/administration/roles"
                                routerLinkActive="active">
                                Role
                            </a>
                        </li>
                        <li [hidden]="sidebar['security']">
                            <a  routerLink="/pet/administration/users"
                                routerLinkActive="active">User</a>
                        </li>
                        <li [hidden]="sidebar['security']">
                            <a  routerLink="/pet/administration/data-assignment"
                                routerLinkActive="active">
                                Data Assignment
                            </a>
                        </li>
                        <li [hidden]="sidebar['security']">
                            <a  routerLink="/pet/administration/workflow"
                                routerLinkActive="active">
                                Workflow
                            </a>
                        </li>
                    </ul>
                </li>
              </div>
            </ul>
        </li>

    </ul>
</div>
